module.exports = __webpack_public_path__ + "img/MailCircleIcon.c65aef21.svg";